import React from "react";
import BaseNumberInput from "oc-ui/react/NumberInput";

export default class NumberInput extends BaseNumberInput {

    classNameGroup() {
        return `input-wrapper ${this.props.className || ''} ${this.props.hidden?"disappear":"appear"}`;
    }

    classNameInput() {
        return this.isValid(this.getInputNumber()) ? '' : 'invalid';
    }

    classNameStep() {
        return `step ${this.props.disabled ? 'disabled' : ''}`;
    }

}
